"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PummelAbilityHandler = exports.PummelActorAbilityFactory = exports.PummelAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const __1 = require("../..");
const Random_1 = require("../../utils/Random");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class PummelAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Pummel;
        this.__typeName = "Pummel";
    }
}
exports.PummelAbilityArgs = PummelAbilityArgs;
let PummelActorAbilityFactory = class PummelActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Pummel", "OneEnemies", 0);
    }
};
PummelActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Pummel")
], PummelActorAbilityFactory);
exports.PummelActorAbilityFactory = PummelActorAbilityFactory;
let PummelAbilityHandler = class PummelAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 45)
            ],
            onHit(sequence) {
                if ((0, Random_1.randomPercent)() <= 25) {
                    container.applyDebuff({
                        attackerId: ability.invokerId,
                        targetId: selectedEnemy,
                        effect: new __1.StunEffectArgs(),
                        duration: Duration_1.Duration.Turns(1),
                        sequence
                    });
                }
            }
        });
    }
};
PummelAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Pummel)
], PummelAbilityHandler);
exports.PummelAbilityHandler = PummelAbilityHandler;
